import React, { PureComponent } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink as BSNavLink
} from 'reactstrap';

const navGroups = {
  management: [{ to: '/dashboard', label: 'DashBoard' },{ to: '/maetoristas', label: 'Mãetoristas' }, { to: '/familias', label: 'Famílias' }]
};

class AdminNavbar extends PureComponent {
  state = {
    navOpen: false
  };

  toggle = () => this.setState({ navOpen: !this.state.navOpen });

  close = () => {
    if (this.state.navOpen) this.state({ navOpen: false });
  };

  render() {
    return (
      <nav className="navbar navbar-expand-md navbar-dark bg-primary">
        <NavbarBrand href="/">gokidsapp.com</NavbarBrand>
        <NavbarToggler onClick={this.toggle} />

        <Collapse isOpen={this.state.navOpen} navbar>
          <ul className="mr-auto navbar-nav">{navGroups.management.map(this.renderNavLink)}</ul>

          <ul className="navbar-nav">
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Mais opções
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={this.props.logout}>Sair</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </ul>
        </Collapse>
      </nav>
    );
  }

  renderNavLink = nav => (
    <li key={nav.to} className="nav-item">
      <NavLink to={nav.to} className="nav-link" activeClassName="active">
        {nav.label}
      </NavLink>
    </li>
  );
}

AdminNavbar.propTypes = {
  logout: PropTypes.func
};

const styles = {};

export default withRouter(AdminNavbar);



// WEBPACK FOOTER //
// ./src/components/AdminNavbar.js